import Div from '@/shared/Div';
import React, { memo } from 'react';
import Map from '../Map';
import Image from '@/shared/Image';
import { parseMediaFromCMS } from '@/utils/image';
import is from '@/utils/is';
import classNames from 'classnames';

function ListWithIcon({
  dataTestId,
  list,
  title,
  className,
}: {
  dataTestId?: string;
  list: any;
  title: string;
  className?: string;
}) {
  if (is.empty.array(list)) return null;
  return (
    <Div
      className={classNames('flex flex-col gap-s4 lg:gap-s5', className)}
      dataTestId={dataTestId}
    >
      <Div className="text-h-3 lg:text-hd-3 text-cti-primary">{title}</Div>
      <Map
        className="border border-solid border-co-subtle rounded-cs p-s5 lg:px-s5 lg:py-s6 flex flex-col gap-s5"
        list={list}
        wrapper="div"
        render={({ icon, text }, index) => (
          <Div className="flex items-center gap-s4" key={index}>
            {icon && icon.data ? (
              <Div className="w-5 flex-shrink-0">
                <Image
                  width={20}
                  height={20}
                  src={parseMediaFromCMS(icon).src}
                  alt=""
                  loading="lazy"
                />
              </Div>
            ) : null}
            <Div className="text-body-lg text-cti-primary">{text}</Div>
          </Div>
        )}
      />
    </Div>
  );
}

export default memo(ListWithIcon);
